import api from "../backAxios"

class PixService {

  async geraPixMensalidades(inscricao, mensalidades) {
    try {
      const pix = await api.post(`/pagamentos/pix/${inscricao}`, mensalidades) 
      return pix.data
    } catch (err) {
      throw err
    }
  }
}

export default new PixService()